// ═══════════════════════════════════════════════════════════════════════════
// PAGE ADMIN RISKLISTS — fragments de rendu purs
// Extrait de page-admin-risklists.ts (découpe god-function `renderRiskListDetail`
// 2026-07) : template de ligne + cases à cocher de phases, PURS (aucun état de
// closure — le tri mutable reste dans la page, appliqué avant l'appel).
// Comportement identique à l'inline.
// ═══════════════════════════════════════════════════════════════════════════
//
// Bare refs utilisées (résolues via core-globals.d.ts) : esc, t.

import type { StdRisk, StageRow } from './page-admin-risklists.js';

/** `<tr>` d'un risque standard (case, catégorie, phases, visibilité, cause,
 * conséquence, actions).
 *
 * `canWrite` conditionne tout ce qui déclenche une écriture : case de sélection
 * en masse, cellules cliquables et boutons ✎ / ✕. Passé en paramètre plutôt que
 * lu depuis `window` pour garder le fragment pur et testable. Défaut `true` :
 * le comportement historique, que fige `page-risklists-fragments.test.ts`.
 */
export function buildStdRiskRow(r: StdRisk, canWrite: boolean = true): string {
  const clickable = canWrite ? `data-edit-std-click="${r.id}"` : '';
  const cursor = canWrite ? 'pointer' : 'default';
  return `<tr data-std-risk-id="${r.id}">
    <td style="width:32px;text-align:center">${canWrite ? `<input type="checkbox" class="std-risk-chk" data-rid="${r.id}">` : ''}</td>
    <td style="cursor:${cursor}" ${clickable}>${esc(r.category || '—')}</td>
    <td style="cursor:${cursor}" ${clickable}>${esc((r.stages || []).join(', ') || '—')}</td>
    <td><span class="badge ${r.visibility === 'privée' ? 'badge-priv' : 'badge-pub'}">${esc(r.visibility)}</span></td>
    <td class="truncate" style="max-width:180px">${esc(r.cause || '—')}</td>
    <td class="truncate" style="max-width:180px">${esc(r.consequence || '—')}</td>
    <td>${
      canWrite
        ? `<button class="btn btn-secondary btn-sm" data-edit-std="${r.id}" title="${esc(t('common.edit'))}">✎</button>
      <button class="btn btn-danger btn-icon" data-del-std="${r.id}" style="margin-left:4px" title="${esc(t('common.delete'))}">✕</button>`
        : ''
    }</td>
  </tr>`;
}

/** Cases à cocher des phases (barre d'affectation en masse). */
export function buildStageCheckboxes(stages: ReadonlyArray<StageRow>): string {
  return stages
    .map(
      (s) =>
        `<label style="display:inline-flex;align-items:center;gap:4px;margin-right:10px;font-size:12px">
      <input type="checkbox" class="bulk-stage-chk" value="${esc(s.name)}"> ${esc(s.name)}
    </label>`,
    )
    .join('');
}
